import Footer from '_components/_MarketingBlogPage/Footer/Footer';

export default Footer;
